import { render, staticRenderFns } from "./icon-referral.vue?vue&type=template&id=7a1ea9c9&scoped=true&"
import script from "./icon-referral.vue?vue&type=script&lang=js&"
export * from "./icon-referral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1ea9c9",
  null
  
)

export default component.exports